import React, { useState } from 'react'

import moment, { type Moment } from 'moment'
import { useSelector } from 'react-redux'

import { DriftDatePicker } from '@driftt/react-dates'

import { orgCreatedAt as orgCreatedAtSelector } from 'modules/org/selectors'

type DateRange = {
  startDate: Date
  endDate: Date
}

type NavigationDatePickerProps = DateRange & {
  updateDates: (props: DateRange) => void
}

export const NavigationDatePicker = ({
  startDate,
  endDate,
  updateDates,
}: NavigationDatePickerProps) => {
  const [focusedInput, setFocusedInput] = useState()
  const orgCreatedAt = useSelector(orgCreatedAtSelector)

  const handleDateChange = (params: {
    startDate: Moment
    endDate?: Moment
  }) => {
    let { startDate: nextStartDate, endDate: nextEndDate } = params

    if (!nextEndDate) {
      nextEndDate = moment(startDate)
    }

    // User has the start date in focus and selected a date beyond the end date
    if (nextStartDate.isAfter(nextEndDate)) {
      nextStartDate = nextEndDate
      nextEndDate = params.startDate
    }

    if (
      !nextStartDate.isSame(moment(startDate)) ||
      !nextEndDate.isSame(moment(endDate))
    ) {
      updateDates({
        startDate: nextStartDate.toDate(),
        endDate: nextEndDate.toDate(),
      })
    }
  }

  const isOutside = (day: moment.MomentInput) => {
    const momentDay = moment(day)
    return (
      momentDay.isAfter(moment(), 'day') || momentDay.isBefore(orgCreatedAt)
    )
  }

  return (
    <DriftDatePicker
      startDate={moment(startDate)}
      endDate={moment(endDate)}
      anchorDirection={'right'}
      onDatesChange={handleDateChange}
      focusedInput={focusedInput}
      onFocusChange={setFocusedInput}
      isOutsideRange={isOutside}
      showQuickSelects={true}
      enableOutsideDays={false}
      hideKeyboardShortcutsPanel
      readOnly
      keepFocusOnInput
      allowSingleDateSelection
    />
  )
}
